import React, { FC } from "react";
import { Popover, Tooltip } from "antd";
import { DocumentSetData } from "../../../../interfaces/documentSet";
import { useTranslation } from "react-i18next";
import useNavigateWithState from "../../../../../common/navigate/hooks/useNavigateWithState";
import useActiveDocumentSet from "../../../../hooks/useActiveDocumentSet";
import "./DuplicateIndicator.scss";

type Props = {
  documentSet: DocumentSetData;
};

const DuplicateIndicator: FC<Props> = ({ documentSet }) => {
  const { t } = useTranslation("overview");
  const { navigateWithState } = useNavigateWithState();
  const { updateActiveDocumentSet } = useActiveDocumentSet();

  if (!documentSet.isDuplicate || !documentSet.duplicateOfId) {
    return null;
  }

  const handleNavigateToOriginal = (event: React.MouseEvent) => {
    event.stopPropagation();
    updateActiveDocumentSet(undefined);
    navigateWithState(`/detail/${documentSet.duplicateOfId}`);
  };

  const popoverContent = (
    <div className="duplicate-indicator__popover-content">
      <p className="duplicate-indicator__popover-description">
        {t("duplicate.popoverDescription")}
      </p>
      <p className="duplicate-indicator__popover-name">
        {documentSet.duplicateOfName}
      </p>
      <button
        type="button"
        className="duplicate-indicator__popover-link"
        onClick={handleNavigateToOriginal}
      >
        {t("duplicate.navigateToOriginal")}
      </button>
    </div>
  );

  return (
    <Popover
      placement="bottomRight"
      trigger="click"
      title={t("duplicate.popoverTitle")}
      content={popoverContent}
    >
      <Tooltip
        placement="top"
        title={
          <span style={{ whiteSpace: "pre-wrap" }}>
            {t("duplicate.tooltip", { name: documentSet.duplicateOfName })}
          </span>
        }
      >
        <div
          className="duplicate-indicator"
          onClick={(event) => event.stopPropagation()}
        >
          <i className="bi bi-flag-fill duplicate-indicator__icon" />
        </div>
      </Tooltip>
    </Popover>
  );
};

export default DuplicateIndicator;
